import { stringifyQueryParams } from './route-helpers';

export const queryString = (queryParams?) =>
  queryParams && Object.keys(queryParams) && Object.keys(queryParams).length ? stringifyQueryParams(queryParams) : '';
